// extracted by mini-css-extract-plugin
export default {"success":"SubmissionNotice_success__VJ81v"};